<template>
  <div class="sidebar" :class="{ collapsed: isCollapsed }">
    <div class="sidebar-header">
      <div class="header-left">
        <img class="avatar" :src="logo" alt="logo" />
        <span class="brand" v-if="!isCollapsed"></span>
      </div>

      <!-- دکمه حرفه‌ای -->
      <button class="collapse-btn" @click="isCollapsed = !isCollapsed">
        <i
          class="bi"
          :class="isCollapsed ? 'bi-chevron-right' : 'bi-chevron-left'"
        ></i>
      </button>
    </div>

    <!-- منو -->
    <ul class="menu list-unstyled px-2">
      <!-- داشبورد -->
      <li class="menu-item">
        <i class="bi bi-speedometer2"></i>

        <span @click="$router.push('/admin-dashboard')" v-if="!isCollapsed">
          {{ currentLang.dashboard }}
        </span>
      </li>

      <!-- مدیران -->
      <!-- <li class="menu-item">
        <i class="bi bi-person-gear"></i>

        <span v-if="!isCollapsed">
          {{ currentLang.admins }}
        </span>
      </li> -->

      <li class="menu-item" @click="toggle('admins')">
        <i class="bi bi-person-gear"></i>

        <span v-if="!isCollapsed">
          {{ currentLang.admins }}
        </span>

        <i
          v-if="!isCollapsed"
          class="bi ms-auto"
          :class="open.admins ? 'bi-chevron-up' : 'bi-chevron-down'"
        ></i>
      </li>

      <ul v-if="open.admins && !isCollapsed" class="submenu list-unstyled">
        <li @click="$router.push('/admin-create')">
          {{ currentLang.admin_create }}
        </li>
        <li @click="$router.push('/admin')">{{ currentLang.admins_list }}</li>
      </ul>

      <!-- مشتریان -->
      <!-- <li class="menu-item">
        <i class="bi bi-people"></i>

        <span v-if="!isCollapsed">
          {{ currentLang.customers }}
        </span>
      </li> -->

      <li class="menu-item" @click="toggle('students')">
        <i class="bi bi-people"></i>

        <span v-if="!isCollapsed">
          {{ currentLang.students }}
        </span>

        <i
          v-if="!isCollapsed"
          class="bi ms-auto"
          :class="open.students ? 'bi-chevron-up' : 'bi-chevron-down'"
        ></i>
      </li>

      <ul v-if="open.students && !isCollapsed" class="submenu list-unstyled">
        <li @click="$router.push('/student-create')">
          {{ currentLang.student_create }}
        </li>
        <li @click="$router.push('/students')">
          {{ currentLang.students_list }}
        </li>

        <li @click="$router.push('/address')">
          {{ currentLang.address_list }}
        </li>
      </ul>

      <!-- محصولات -->
      <li class="menu-item" @click="toggle('products')">
        <i class="bi bi-box-seam"></i>

        <span v-if="!isCollapsed">
          {{ currentLang.products_section }}
        </span>

        <i
          v-if="!isCollapsed"
          class="bi ms-auto"
          :class="open.products ? 'bi-chevron-up' : 'bi-chevron-down'"
        ></i>
      </li>

      <ul v-if="open.products && !isCollapsed" class="submenu list-unstyled">
        <li @click="$router.push('/categories')">
          {{ currentLang.product_categories }}
        </li>
        <li @click="$router.push('/product-create')">{{ currentLang.add_products }}</li>
        <li @click="$router.push('/products')">{{ currentLang.products }}</li>

      </ul>

      <!-- تعریف پایه -->
      <li class="menu-item" @click="toggle('base')">
        <i class="bi bi-database"></i>

        <span v-if="!isCollapsed">
          {{ currentLang.base_definition }}
        </span>

        <i
          v-if="!isCollapsed"
          class="bi ms-auto"
          :class="open.base ? 'bi-chevron-up' : 'bi-chevron-down'"
        ></i>
      </li>

      <ul v-if="open.base && !isCollapsed" class="submenu list-unstyled">
        <li @click="$router.push('/payment-methods')">{{ currentLang.paymentMethods }}</li>
        <li @click="$router.push('/shipping-methods')">{{ currentLang.shipping_methods }}</li>
      </ul>

      <!-- سفارشات -->
      <li class="menu-item" @click="toggle('orders')">
        <i class="bi bi-cart"></i>

        <span v-if="!isCollapsed">
          {{ currentLang.orders_section }}
        </span>

        <i
          v-if="!isCollapsed"
          class="bi ms-auto"
          :class="open.orders ? 'bi-chevron-up' : 'bi-chevron-down'"
        ></i>
      </li>

      <ul v-if="open.orders && !isCollapsed" class="submenu list-unstyled">
        <li @click="$router.push('/order-create')" >{{ currentLang.add_order }}</li>
        <li @click="$router.push('/orders')" >{{ currentLang.orders }}</li>
        <li @click="$router.push('/invoices')">{{ currentLang.invoices }}</li>
      </ul>
    </ul>
  </div>
</template>



<script setup>
import { ref, computed } from "vue";
import logo from "@/assets/logo.jpg";
import { lang } from "@/plugins/lang";

import enLanguage from "@/locales/en/menus";
import faLanguage from "@/locales/fa/menus";

const translations = {
  en: enLanguage,
  fa: faLanguage,
};

const currentLang = computed(() => translations[lang.value]);

const isCollapsed = ref(false);

const open = ref({
  dashboard: false,
  pages: false,
  apps: false,
  widgets: false,
  forms: false,
  charts: false,
});

const toggle = (menu) => {
  open.value[menu] = !open.value[menu];
};
</script>

<style>
/* =========================
   SIDEBAR BASE
========================= */

.sidebar {
  width: 250px;
  height: 100vh;
  padding: 20px 15px;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
}

.sidebar.collapsed {
  width: 85px;
}

/* =========================
   HEADER
========================= */

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand {
  font-size: 18px;
  font-weight: 600;
  color: #343a40;
}

/* =========================
   AVATAR
========================= */

.avatar {
  width: 85px;
  height: 85px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.sidebar.collapsed .avatar {
  width: 50px;
  height: 50px;
  margin: 0 auto;
}

/* =========================
   COLLAPSE BUTTON
========================= */

.collapse-btn {
  border: none;
  background: #f1f3f5;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.collapse-btn i {
  font-size: 14px;
}

.collapse-btn:hover {
  background: #6366f1;
  color: #fff;
  transform: scale(1.05);
}

/* =========================
   MENU
========================= */

.menu {
  padding: 0;
  margin: 0;
  list-style: none;
  flex: 1;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #495057;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 6px;
}

.menu-item i:first-child {
  font-size: 18px;
  min-width: 22px;
  text-align: center;
}

.menu-item:hover {
  background: #f8f9fa;
  color: #212529;
}

/* وقتی collapsed باشه متن مخفی شه ولی آیکون وسط بیاد */

.sidebar.collapsed .menu-item {
  justify-content: center;
}

.sidebar.collapsed .menu-item span {
  display: none;
}

/* =========================
   SUBMENU
========================= */
/* SUBMENU */

/* =========================
   SUBMENU (LTR + RTL FIX)
========================= */

.submenu {
  list-style: none;
  margin: 0;
  padding: 4px 0;
}

/* حالت انگلیسی (LTR) */
html[dir="ltr"] .submenu {
  padding-left: 36px;
}

/* حالت فارسی (RTL) */
html[dir="rtl"] .submenu {
  padding-right: 36px;
}

.submenu li {
  padding: 6px 0;
  font-size: 14px;
  color: #6c757d;
  cursor: pointer;
  transition: 0.2s;
}

.sumenu li:hover {
  color: #212529;
}

/* =========================
   ACTIVE STATE (Optional)
========================= */

.menu-item.active {
  background: #eef2ff;
  color: #6366f1;
}

/* =========================
   MOBILE
========================= */

@media (max-width: 991px) {
  .sidebar {
    width: 260px !important;
  }

  .sidebar.collapsed {
    width: 260px !important;
  }
}
</style>